export default __webpack_public_path__ + "static/cloud-native-journey-07c400c704127e4efc044b5e12ffbab2.webp";